import type { ActiveElement, Chart, ChartType } from "chart.js";

export default function <T>(
  elements: ActiveElement[],
  chart: Chart<ChartType, T[]>
): T | undefined {
  if (!elements || elements.length === 0) return;

  const pointClickedIndex = elements[0].index;
  return chart.config.data.datasets[0].data[pointClickedIndex];
}
